import angular from "angular";
import AssignDocumentModal from "./AssignDocumentModal.vue";
import Vue from "vue";
import "ngVue";

export default angular
    .module("admin.dashboard.students.view.documents.components.assignDocumentModal", [])
    .directive("assignDocumentModal", [
        "createVueComponent",
        function (createVueComponent) {
            return createVueComponent(
                Vue.component("AssignDocumentModal", AssignDocumentModal),
            );
        },
    ]);
